import { c as _c } from "react/compiler-runtime";
import { getChannel } from "@website/utils/channel/get-channel";
import { logoSchema } from "@website/widget/header/logo/schema";
export function Logo(t0) {
  const $ = _c(7);
  const {
    minimalLogo
  } = t0;
  const {
    label,
    image,
    title
  } = minimalLogo ? logoSchema.minimal : logoSchema[getChannel() as keyof typeof logoSchema] || logoSchema.default;
  const t1 = `${label} logo`;
  const t2 = (image as unknown as {
    src: string;
  }).src as string;
  let t3;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== title) {
    t3 = <img alt={t1} className="h-8 w-auto lg:h-10" height={78} loading="lazy" fetchPriority="high" src={t2} title={title} width={137} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== label || $[5] !== t3) {
    t4 = <a aria-label={label} href="/">{t3}</a>;
    $[4] = label;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}